import { debounce } from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { getQuestionnaireFormsApi } from '../api/requester'

export const useQuestionnaireForms = ({ companyId, page = 1, perPage = 10, timming = 300 }) => {
  const [data, setData] = useState([])
  const [total, setTotal] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const getQuestionnaireForms = useCallback(
    debounce(async ({ companyId, page, perPage }) => {
      setLoading(true)
      const params = { company_id: companyId, page, per_page: perPage }
      try {
        const res = await getQuestionnaireFormsApi({ params })
        setData((pre) => [...pre, ...res?.data?.questionnaire_forms])
        setTotal(res?.data?.total_counts)
      } catch (error) {
        console.error('Error fetching questionnaire forms:', error)
        setError(error)
      } finally {
        setLoading(false)
      }
    }, timming),
    [timming]
  )

  useEffect(() => {
    getQuestionnaireForms({ companyId, page, perPage })
  }, [getQuestionnaireForms, companyId, page, perPage])

  return {
    data,
    total,
    loading,
    error,
  }
}
